import React from "react";
import { Box, Stack, Avatar, Typography } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getFundInitial, getLogoUrl } from "../../utils/getLogoUrl";
import { getTrendColor, hasTrend } from "../../utils/finfactorUi.utils";

const BrokerHeaderBanner = ({ brokerInfo }) => {
  return (
    <Box
      sx={{
        borderRadius: "16px",
        p: { xs: 2, md: 3 },
        mb: 4,
        border: "1px solid #01419A",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: "space-between",
        background: "linear-gradient(70.67deg, #000428 -15.33%, #002647 100%)",
        gap: { xs: 2.5, md: 0 },
      }}
    >
      <Stack direction="row" spacing={3} alignItems="center">
        <Box
          sx={{
            p: "4px",
            background: "linear-gradient(135deg, #46A8DC 0%, #1483BD 100%)",
            borderRadius: "8px",
            display: "flex",
          }}
        >
          <Avatar
            src={getLogoUrl(brokerInfo)}
            variant="rounded"
            sx={{
              width: 40,
              height: 40,
              bgcolor: "transparent",
              fontSize: "20px",
              fontWeight: "700",
              color: "white",
            }}
          >
            {getFundInitial(brokerInfo)}
          </Avatar>
        </Box>
        <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "white" }}>
          {brokerInfo.name}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        spacing={{ xs: 2.5, md: 5 }}
        alignItems="center"
        sx={{
          width: { xs: "100%", md: "auto" },
          justifyContent: { xs: "space-between", md: "flex-end" },
        }}
      >
        <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "20px" },
              fontWeight: "700",
              color: "white",
            }}
          >
            {brokerInfo.totalValue}
          </Typography>
          <Box
            sx={{
              fontSize: "11px",
              color: getTrendColor(brokerInfo.change, brokerInfo.isPositive),
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            {hasTrend(brokerInfo.change, brokerInfo.isPositive) &&
              (brokerInfo.isPositive ? (
                <ArrowDropUpIcon sx={{ fontSize: 16 }} />
              ) : (
                <ArrowDropDownIcon sx={{ fontSize: 16 }} />
              ))}
            {brokerInfo.change}
            {brokerInfo.change !== "-" && ` (${brokerInfo.changePercentage})`}
          </Box>
        </Box>

        <Box
          sx={{
            height: 35,
            width: "1px",
            bgcolor: "rgba(255,255,255,0.2)",
            display: { xs: "none", md: "block" },
          }}
        />

        <Box>
          <Typography
            sx={{
              fontSize: "10px",
              color: "rgba(255,255,255,0.5)",
              display: "block",
              mb: 0.5,
            }}
          >
            Purchase Cost
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              fontWeight: "700",
              color: "white",
            }}
          >
            {brokerInfo.purchaseCost}
          </Typography>
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: "10px",
              color: "rgba(255,255,255,0.5)",
              display: "block",
              mb: 0.5,
            }}
          >
            Gain (CAGR)
          </Typography>
          <Box
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              fontWeight: "700",
              color: getTrendColor(brokerInfo.gain, brokerInfo.isPositive),
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {hasTrend(brokerInfo.gain, brokerInfo.isPositive) &&
              (brokerInfo.isPositive ? (
                <ArrowDropUpIcon sx={{ fontSize: 20 }} />
              ) : (
                <ArrowDropDownIcon sx={{ fontSize: 20 }} />
              ))}
            {brokerInfo.gain}
            {brokerInfo.gain !== "-" && ` (${brokerInfo.gainPercentage})`}
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default BrokerHeaderBanner;
